import languageModel from '../language.model';
import modelBaseV2 from '../model-base-v2.model';

let activeMenuList = [];

const EXCEPTION_PATH = [
  '/',
  '/coming-soon',
  '/home',
  '/reset',
  '/user-profile',
];

const navigationModel = {
  get activeMenuList() {
    return structuredClone(activeMenuList);
  },

  clearActiveMenuList: () => {
    activeMenuList = [];
  },

  getActiveMenuList: (params) => {
    return modelBaseV2.get('/api/user/menu/web', params)
      .then(data => {
        activeMenuList = data || [];
        return data;
      });
  },

  getBreadcrumbData: () => {
    const currentPath = getCurrentPath();
    const menuItem = navigationModel.activeMenuList.find(item => item.path === currentPath);
    let breadcrumb = getMenuLineage(menuItem);

    return breadcrumb;
  },

  getCurrentMenuTitle: () => {
    const currentPath = getCurrentPath();
    const menuItem = navigationModel.activeMenuList.find(item => item.path === currentPath);
    if (menuItem) {
      return languageModel.getText(menuItem.menuID, menuItem.name);
    }

    return '';
  },

  getCurrentMenuID: () => {
    const currentPath = getCurrentPath();
    if (navigationModel.activeMenuList){
      const menuItem = navigationModel.activeMenuList.find(item => item.path === currentPath);
      if (menuItem) {
        return menuItem.menuID;
      }
    }
    

    return '';
  },

  logMenu: function (menuId = '') {
    if (menuId === '') {
      return;
    }

    const params = {
      menuLog: [
        { menuId: menuId }
      ]
    }

    return modelBaseV2.post('/api/menu/log', { body: params });
  },

  canAccessMenuPath: (requestedPath = '') => {
    // Remove anchor and query string
    requestedPath = requestedPath.split(/[?#]/)[0];
    let canAccess = EXCEPTION_PATH.includes(requestedPath)
      || !!navigationModel.activeMenuList.find(item => item.path === requestedPath);
    return canAccess;
  },
}

const getCurrentPath = () => {
  const route = m.route.get();
  return route ? route.split(/([/?]){2}|[?]/g)[0] : '/';
}

const getMenuLineage = (menuItem) => {
  let menuLineage = [];
  let parentMenu;

  if (!menuItem) {
    return menuLineage;
  }

  parentMenu = navigationModel.activeMenuList.find(item => item.menuID === menuItem.parentMenuID);

  if (parentMenu) {
    menuLineage = menuLineage.concat(getMenuLineage(parentMenu));
  }

  menuLineage.push(menuItem);

  return menuLineage;
}

export default navigationModel;
